/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1SerievideoSeriesSerieidMutationRequest,
  PostApiV1SerievideoSeriesSerieidMutationResponse,
  PostApiV1SerievideoSeriesSerieidPathParams,
  PostApiV1SerievideoSeriesSerieid400,
  PostApiV1SerievideoSeriesSerieid401,
  PostApiV1SerievideoSeriesSerieid404,
  PostApiV1SerievideoSeriesSerieid500,
} from "../../types/serieVideoRegistroController/PostApiV1SerievideoSeriesSerieid.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1SerievideoSeriesSerieidUrl(
  serieId: PostApiV1SerievideoSeriesSerieidPathParams["serieId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/serievideo/series/${serieId}` as const,
  };
  return res;
}

/**
 * @description Cria um vídeo na série informada na rota (serieId), via multipart/form-data, com título/resumo/embed no idioma corrente e imagem de capa opcional. **(Requer Authorization para autenticação)**
 * @summary Criar vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/series/:serieId}
 */
export async function postApiV1SerievideoSeriesSerieid(
  serieId: PostApiV1SerievideoSeriesSerieidPathParams["serieId"],
  data?: PostApiV1SerievideoSeriesSerieidMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1SerievideoSeriesSerieidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1SerievideoSeriesSerieidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoSeriesSerieid400
      | PostApiV1SerievideoSeriesSerieid401
      | PostApiV1SerievideoSeriesSerieid404
      | PostApiV1SerievideoSeriesSerieid500
    >,
    PostApiV1SerievideoSeriesSerieidMutationRequest
  >({
    method: "POST",
    url: getPostApiV1SerievideoSeriesSerieidUrl(serieId).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
